import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "pb-8 text-primary" }
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "font-semibold text-lg" }, "Back", -1)
const _hoisted_3 = {
  key: 1,
  class: "mt-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ArrowLeftIcon = _resolveComponent("ArrowLeftIcon")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.showBackButton)
      ? (_openBlock(), _createBlock("button", {
          key: 0,
          class: "flex flex-row items-center mb-3",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args)))
        }, [
          _createVNode(_component_ArrowLeftIcon, { class: "h-5 w-5 mr-2" }),
          _hoisted_2
        ]))
      : _createCommentVNode("", true),
    _createVNode("h2", {
      class: "text-2xl font-bold",
      innerHTML: _ctx.title
    }, null, 8, ["innerHTML"]),
    (_ctx.subtitle)
      ? (_openBlock(), _createBlock("p", _hoisted_3, [
          _createVNode("span", { innerHTML: _ctx.subtitle }, null, 8, ["innerHTML"])
        ]))
      : _createCommentVNode("", true)
  ]))
}